var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    {
      attrs: {
        title: "Adjust team size limit",
        label: "Update",
        disabled: _vm.isDisabledSubmit,
        submitLoading: _vm.submitLoading
      },
      on: {
        "backdrop-close": function($event) {
          return _vm.$emit("close-modal")
        },
        "backdrop-action": _vm.onUpdate
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "flex flex-col gap-5 px-8",
          style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col items-center justify-center gap-1 bg-slate-200 rounded-tl-none rounded py-3"
            },
            [
              _c("div", { staticClass: "flex items-center gap-4" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "outline-none flex h-6 w-6 items-center justify-center rounded-full border border-slate-600 transition-all duration-300",
                    class: [
                      _vm.teamSizeLimitInput <= 1
                        ? "text-slate-600 bg-slate-400 pointer-events-none"
                        : "text-dark-purple-100 bg-pure-white hover:bg-light-purple-100"
                    ],
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.teamSizeLimitInput =
                          Number(_vm.teamSizeLimitInput) - 1
                      }
                    }
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "h-4 w-4",
                      attrs: { icon: "minus" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.teamSizeLimitInput,
                      expression: "teamSizeLimitInput"
                    }
                  ],
                  staticClass:
                    "outline-none flex w-50 h-18 items-center justify-center rounded border border-slate-500 text-center text-6xl font-bold focus:border-light-purple",
                  class: [
                    _vm.teamSizeLimitInput <= 0
                      ? "text-error-300"
                      : "text-dark-purple-100"
                  ],
                  attrs: {
                    type: "number",
                    name: "credit_count",
                    id: "credit_count"
                  },
                  domProps: { value: _vm.teamSizeLimitInput },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.teamSizeLimitInput = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "outline-none flex h-6 w-6 items-center justify-center rounded-full border border-slate-600 text-dark-purple-100 bg-pure-white hover:bg-light-purple-100 transition-all duration-300",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.teamSizeLimitInput =
                          Number(_vm.teamSizeLimitInput) + 1
                      }
                    }
                  },
                  [
                    _c("BlIcon", {
                      staticClass: "h-4 w-4",
                      attrs: { icon: "plus" }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex-col items-center" },
                [
                  _c("BlTextBody3", { attrs: { text: "seats(s)" } }),
                  _vm._v(" "),
                  _vm.teamSizeLimitInput < 0
                    ? _c("BlTextBody3", {
                        staticClass: "text-error-300",
                        attrs: { text: "Please input seats(s) starts from 1" }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a190c21", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a190c21","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/center/centerInformation/EditTeamSizeLimitModal.vue
// module id = null
// module chunks = 